/**
 * Model object to keep Error related information
 */
class ErrorInfoObj {
  constructor() {
    this.statusCode = ''
    this.errorCode = ''
    this.messages = []
    this.stack = ''
  }

  getStatusCode() {
    return this.statusCode
  }

  setStatusCode(statusCode) {
    this.statusCode = statusCode
  }

  getErrorCode() {
    return this.errorCode
  }

  setErrorCode(errorCode) {
    this.errorCode = errorCode
  }

  getMessages() {
    return this.messages
  }

  getMessage() {
    return this.messages ? this.messages[0] : ''
  }

  addMessage(message) {
    this.messages.push(message)
  }

  setMessages(messages) {
    this.messages = messages
  }

  getStack() {
    return this.stack
  }

  setStack(stack) {
    this.stack = stack
  }

  parse(rawError, responseName) {
    if (rawError) {
      if (rawError.stack) {
        this.setStack(rawError.stack)
      }

      if (rawError.resultCode && rawError.resultCode !== '0') {
        this.setErrorCode(rawError.resultCode)
        this.addMessage(rawError.resultMessage)
      } else if (
        (rawError.statusCode && rawError.statusCode !== 200) ||
        rawError.exceptionCode
      ) {
        this.setErrorCode(rawError.exceptionCode)
        this.addMessage(rawError.exception)
      } else if (
        responseName &&
        rawError[responseName] &&
        rawError[responseName].error
      ) {
        this.setErrorCode(rawError[responseName].error.code)
        this.addMessage(rawError[responseName].error.desc)
      } else if (rawError.message === 'jwt expired') {
        this.setErrorCode(rawError.status)
        this.addMessage(rawError.message)
      } else if (rawError.status && rawError.status !== 'Success') {
        // So far it's only Postal code API that it is needed for
        this.setErrorCode(404)
        this.addMessage('No Match Found')
      }
    }
  }

  isError() {
    return !!this.errorCode
  }
}

export { ErrorInfoObj }
